import * as types from './mutation-types'
import Vue from 'vue'
import { IFleetState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { FLEETS_DETAIL_TABS, FleetTabs } from '@/models/ui/FleetTabs'
import { UiTab } from '@/models/ui/UiTab'
import { FleetUi } from '@/models/ui/FleetUi'
import { FilterFleet } from '@/models/filter/FilterFleet'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'
import { FleetUiState, buildFleetUIStateId } from '@/models/ui/FleetUiState'
import { ConsoleRow } from '@/models/ui/ConsoleRow'
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations: MutationTree<IFleetState> = {      
  //deselectione la fleet
  [types.FLEET_UNSELECT]: state => {},
  [types.FLEET_SELECT_DETAIL_SUCCESS]: (state, fleet:AloDbFleet) => {
    state.status = `success loading fleet ${fleet.FLE_ID}`
    const newIdx = state.detailFleets.findIndex(it => it.fleet.FLE_ID == fleet.FLE_ID)
    if (newIdx == -1) {
      //on cree un nouvel onglet map
      const leftCmp = FLEETS_DETAIL_TABS.find(it => it.cmp == 'FleetDetailMap')
      if (leftCmp) {
        const newLeft = new UiTab(leftCmp)
        leftCmp.id++ //augmente l'id pour la prochaine creation

        /*const rightCmp = FLEETS_DETAIL_TABS.find(it => it.cmp == "FleetDetailScienceGraphicsList")      
        const newRight = new UiTab(rightCmp)
        rightCmp.id++ //augmente l'id pour la prochaine creation     */

        state.detailFleets.push(
          new FleetUi({
            fleet,
            tabsleft: new FleetTabs({
              tabs: [newLeft],
              selected: `${newLeft.cmp}-${newLeft.id}`
            }),
            tabsright: new FleetTabs({
              selected: 'FleetMenu-0'
            })
          })
        )
      }
    }    
  },
  [types.FLEET_UPDATE_DETAIL_SUCCESS]: (state, fleet:AloDbFleet) => {    
    const newIdx = state.detailFleets.findIndex(it => it.fleet.FLE_ID == fleet.FLE_ID)
    if (newIdx >=0) {
      //on met a jour les donnees de la fleet
      Vue.set(state.detailFleets[newIdx], 'fleet', fleet)    
    }
  },  
  [types.FLEET_SELECT_DETAIL_ERROR]: (state, id:number) => {
    state.status = `error loading fleet ${id}`
  },
  //deselectione la fleet
  [types.FLEET_UNSELECT_DETAIL]: (state, id:number) => {
    const newIdx = state.detailFleets.findIndex(it => it.fleet.FLE_ID == id)
    if (newIdx > -1) {
      //reset des données sciences et navigation...
      const fleet = state.detailFleets[newIdx].fleet
      //si des images on été en cache on les vide
      if ((window as any)[`imgcache_${fleet.FLE_ID}`]) {
        ;(window as any)[`imgcache_${fleet.FLE_ID}`] = {}
      }           
      if (state.currentDetailFleet.fleet.FLE_ID == id) state.currentDetailFleet = new FleetUi()
      state.detailFleets.splice(newIdx, 1)
    }
  },
  [types.FLEET_SELECT_DETAIL]: (state, id:number) => {
    const fleetUi = state.detailFleets.find(it => it.fleet.FLE_ID == id)
    state.currentDetailFleet = fleetUi || new FleetUi()    
  },
  [types.FLEET_NAVTO_DETAIL]: (state, { cmp, isleft, id, label }:{ cmp:string, isleft:boolean, id:number, label:string }) => {
    const tabsFleet = isleft ? state.currentDetailFleet.tabsleft : state.currentDetailFleet.tabsright
    const newIdx = tabsFleet.tabs.findIndex(it => it.cmp == cmp && it.id == id)    
    if (newIdx == -1) {
      const cmpfound = FLEETS_DETAIL_TABS.find(it => it.cmp == cmp)
      if (cmpfound) {        
        const newComp = new UiTab({ ...cmpfound, label: label || cmpfound.label })
        cmpfound.id++ //augmente l'id pour la prochaine creation
        tabsFleet.tabs.push(newComp)
        tabsFleet.selected = `${cmp}-${newComp.id}`        
        return
      }
    }
    tabsFleet.selected = `${cmp}-${id}`    
  },
  [types.FLEET_SET_LEFTPANEL_SIZE]: (state, size:string) => {
    state.currentDetailFleet.leftPanelWidth = size
  },
  [types.FLEET_UNSELECT_TAB]: (state, { cmp, isleft, id }:{ cmp:string, isleft:boolean, id:number }) => {
    const tabsFleet = isleft ? state.currentDetailFleet.tabsleft : state.currentDetailFleet.tabsright
    const newIdx = tabsFleet.tabs.findIndex(it => it.cmp == cmp && it.id == id)
    if (newIdx > -1) {
      tabsFleet.tabs.splice(newIdx, 1)
    }
    if (tabsFleet.selected == `${cmp}-${id}`)
      tabsFleet.selected =
        tabsFleet.tabs.length > 0 ? `${tabsFleet.tabs[0].cmp}-${tabsFleet.tabs[0].id}` : 'FleetMenu-0'
  },
  [types.FLEET_RENAME_DETAIL]: (state, { cmp, isleft, id, label }:{ cmp:string, isleft:boolean, id:number, label:string }) => {
    const tabsFleet = isleft ? state.currentDetailFleet.tabsleft : state.currentDetailFleet.tabsright
    const newIdx = tabsFleet.tabs.findIndex(it => it.cmp == cmp && it.id == id)
    if (newIdx > -1) {
      tabsFleet.tabs[newIdx].label = label
    }
  },
  [types.FLEET_MOVE_TAB]: (state, { cmp, isleft, id }:{ cmp:string, isleft:boolean, id:number }) => {
    const tabsFleet = isleft ? state.currentDetailFleet.tabsleft : state.currentDetailFleet.tabsright
    const newIdx = tabsFleet.tabs.findIndex(it => it.cmp == cmp && it.id == id)
    if (newIdx > -1) {
      const tagetTabsFleet = isleft ? state.currentDetailFleet.tabsright : state.currentDetailFleet.tabsleft
      const selectedTab = tabsFleet.tabs.splice(newIdx, 1)[0]
      if (tabsFleet.selected == `${cmp}-${id}`)
        tabsFleet.selected =
          tabsFleet.tabs.length > 0 ? `${tabsFleet.tabs[0].cmp}-${tabsFleet.tabs[0].id}` : 'FleetMenu-0'
      //on attend le next tick pour reconstruir le composant pour etre certain que les listener on bien été clear avant la reconstruction
      Vue.nextTick(() => {
        tagetTabsFleet.tabs.push(selectedTab)
        tagetTabsFleet.selected = `${cmp}-${id}`
      })
    }
  },
  [types.FLEET_SET_ONGOING_FILTER]: (state, ongoing:boolean) => {
    state.filterFleet.onGoing = ongoing
  },
  [types.FLEET_RESET_FILTER]: (state, ongoing:boolean) => {
    state.filterFleet = new FilterFleet()
  },  
  [types.FLEET_ADD_CONSOLE_ROW]: (state, { consoleMsgs, row }:{ consoleMsgs:ConsoleRow[], row:ConsoleRow }) => {
    consoleMsgs.push(row)
  },
  [types.FLEET_CLEAR_CONSOLE]: (state, fleetState:FleetUiState) => {
    fleetState.consoleMsgs = []
  }  
}

export default mutations